import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import { AppStates, Publication } from '../../../../..';
import PageNavigationToolbar from './PageNavigationToolbar';
import PageJumpTool from './PageJumpTool/PageJumpTool';
import { ToolbarDirection } from '../../actions/UIModeAction';

interface NewPageNavigatorProps {
  readonly dispatch: Dispatch<Action>;
  readonly publication: Publication | undefined;
  readonly toolbarDirection: ToolbarDirection;
  readonly onTableOfContentsButtonClick?: () => void;
}

interface NewPageNavigatorSatte {
  pageJumpToolIsShown: boolean;
}

class NewPageNavigator extends React.PureComponent<NewPageNavigatorProps, NewPageNavigatorSatte> {
  public constructor(props: Readonly<NewPageNavigatorProps>) {
    super(props);

    this.state = {
      pageJumpToolIsShown: false,
    };
  }
  public render() {
    const { toolbarDirection, publication, onTableOfContentsButtonClick }  = this.props;

    if (publication === undefined) {
      throw new Error('Unexpected state.');
    }

    // XXX: ツールバー水平配置の時にとりあえず左下に置いてみるが仕様未確定
    const left = (() => {
      if (toolbarDirection === ToolbarDirection.VerticalRight) {
        return 'initial';
      }
      return toolbarDirection === ToolbarDirection.Horizontal ? '30px' : '74px';
    })();

    const right = toolbarDirection === ToolbarDirection.VerticalRight ? '74px' : 'initial';

    const containerStyle: React.CSSProperties = {
      left,
      right,
      bottom: '80px',
      display: 'flex',
      position: 'absolute',
      alignItems: 'flex-end',
    };

    const togglePageJumpTool = () => {
      this.setState({ pageJumpToolIsShown: !this.state.pageJumpToolIsShown });
    };

    const hidePageJumpTool = () => {
      this.setState({ pageJumpToolIsShown: false });
    };

    return (
      <div style={containerStyle}>
        <PageNavigationToolbar onTogglePageJumpToolButtonClick={togglePageJumpTool}
          onTableOfContentsButtonClick={onTableOfContentsButtonClick}/>
        { this.state.pageJumpToolIsShown ? <PageJumpTool onCloseButtonClick={hidePageJumpTool}/>
          : null }
      </div>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => {
  return {
    publication: appStates.publication,
    toolbarDirection: appStates.uimode.toolbarDirection,
  };
};

export default connect(mapStateToProps)(NewPageNavigator);
